import _ from 'lodash'

import { getResponsabilidade, getUnidades, salvarUnidades } from '../util/applicationContext'
import {
  OPCAO_RESP_POR_AGIR,
  OPCAO_RESP_TECNICA,
  OPCAO_RESP_TECNICA_NAO_RESP_AGIR
} from '../reducers/filtrosReducer'

const NIVEL_SECRETARIA_GERAL = 4
const NIVEL_UNIDADE_DIRETORIA = 2
const NIVEL_UNIDADE_ASSESORIA = 1

export const validarUnidadesAtuais = (unidadesAtuais) => {
  const qtdeUnidades = _.size(_.filter(unidadesAtuais, (unidade) => isUnidade(unidade)))
  const qtdeSubunidades = _.size(_.filter(unidadesAtuais, (unidade) => isSubunidade(unidade)))

  if (qtdeSubunidades > 0 && qtdeUnidades !== 1) {
    throw new Error(
      'subunidades só devem ser selecionáveis para única unidade selecionada obrigatoriamente!'
    )
  }
}

export const determinarCodigosUnidades = (unidadesAtuais, url) => {
  validarUnidadesAtuais(unidadesAtuais)
  let r = url
  if (temUnidadesAtuaisSelecionadas(unidadesAtuais)) {
    _.keys(unidadesAtuais).forEach((codigoUnidade, index) => {
      if (index === 0) {
        r = r.concat(`?codigosUnidades=${codigoUnidade}`)
      } else {
        r = r.concat(`&codigosUnidades=${codigoUnidade}`)
      }
    })
  }
  return r
}

export const determinarResponsabilidadeUnidade = (responsabilidadeUnidade, url) => {
  let r = url
  switch (responsabilidadeUnidade) {
    case OPCAO_RESP_TECNICA:
      r = r.concat('&responsabilidadeUnidade=RESP_TECNICA')
      break
    case OPCAO_RESP_POR_AGIR:
      r = r.concat('&responsabilidadeUnidade=RESP_AGIR')
      break
    case OPCAO_RESP_TECNICA_NAO_RESP_AGIR:
      r = r.concat('&responsabilidadeUnidade=RESP_TECNICA_NAO_RESP_AGIR')
      break
    default:
      throw new Error(`${responsabilidadeUnidade} não implementado!`)
  }
  return r
}

export const iniciarResponsabilidadeUnidadeAtual = () =>
  getResponsabilidade() || OPCAO_RESP_POR_AGIR

export const getUnidadesSorted = (unidades, unidadeVinculacaoHierarquica) => {
  if (!_.isNil(unidadeVinculacaoHierarquica)) {
    const unidadePadrao = findUnidadeByCodigoUnidade(unidades, unidadeVinculacaoHierarquica)
    if (!_.isNil(unidadePadrao)) {
      const outrasUnidades = _.without(unidades, unidadePadrao)
      return _.concat(
        unidadePadrao,
        _.sortBy(outrasUnidades, (unidade) => unidade.sigla)
      )
    }
  }
  return _.sortBy(unidades, (unidade) => unidade.sigla)
}

export const iniciarUnidadesAtuais = (
  prevUnidadesAtuais,
  unidades,
  unidadeVinculacaoHierarquica
) => {
  let unidadesAtuais = prevUnidadesAtuais
  if (!temUnidadesAtuaisSelecionadas(unidadesAtuais) && _.size(unidades)) {
    // Unidades armazenadas em localStorage...
    const unidadesStored = _.values(getUnidades())
    // Unidades armazenadas em localStorage em que o usuário tem visão...
    let unidadesSelecionadas = _.filter(
      _.map(unidadesStored, (unidade) => getUnidadesSelecionadas(unidades, unidade)),
      (unidade) => unidade != null
    )

    if (_.size(unidadesSelecionadas)) {
      // unidadesAtuais = unidades armazenadas em localStorage em que o usuário tem visão...
      unidadesAtuais = _.keyBy(unidadesSelecionadas, (unidade) => unidade.codigoUnidade)
    } else {
      // unidadesAtuais = primeira unidade em que o usuário tem visão...
      const unidadesSorted = getUnidadesSorted(unidades, unidadeVinculacaoHierarquica)
      let unidadeSelecionada = null
      if (!_.isNil(unidadeVinculacaoHierarquica)) {
        unidadeSelecionada = findUnidadeByCodigoUnidade(
          unidadesSorted,
          unidadeVinculacaoHierarquica
        )
      }
      if (_.isNil(unidadeSelecionada)) {
        unidadeSelecionada = unidadesSorted[0]
      }
      if (unidadeSelecionada) {
        unidadesAtuais = { [unidadeSelecionada.codigoUnidade]: unidadeSelecionada }
      }
    }

    unidadesAtuais = removerSubunidadesAtuaisSeNecessario(unidadesAtuais, unidades)
    salvarUnidades(unidadesAtuais)
  }

  return unidadesAtuais
}

export const atualizarUnidadesAtuais = (unidadeClicked, checked, prevUnidadesAtuais, unidades) => {
  const unidadeSelected = unidadeClicked
  let unidadesAtuais = prevUnidadesAtuais
  if (checked) {
    unidadesAtuais = temUnidadesAtuaisSelecionadas(unidadesAtuais)
      ? { ...unidadesAtuais, [unidadeSelected.codigoUnidade]: unidadeSelected }
      : { [unidadeSelected.codigoUnidade]: unidadeSelected }
  } else {
    unidadesAtuais = temUnidadesAtuaisSelecionadas(unidadesAtuais)
      ? _.omit(unidadesAtuais, unidadeSelected.codigoUnidade)
      : unidadesAtuais
    if (isUnidade(unidadeSelected) && unidadeSelected.nivel !== NIVEL_SECRETARIA_GERAL) {
      unidadesAtuais = removerSubunidades(unidadeSelected, unidadesAtuais)
    }
  }
  unidadesAtuais = removerSubunidadesAtuaisSeNecessario(unidadesAtuais, unidades)
  salvarUnidades(unidadesAtuais)

  return unidadesAtuais
}

export const atualizarTodasUnidadesAtuais = (unidades) => {
  const unidadesAtuais = unidades ? { ...unidades } : null
  salvarUnidades(unidadesAtuais)

  return unidadesAtuais
}

export const temUnidadesAtuaisSelecionadas = (unidadesAtuais) => Boolean(_.size(unidadesAtuais))

export const temVinculacaoHierarquica = (unidadeVinculacaoHierarquica) =>
  !_.isNil(unidadeVinculacaoHierarquica)

export const getUnidadesSuperioresAtuais = (unidadesAtuais, unidades) =>
  _.uniqBy(
    _.map(unidadesAtuais, (unidade) => getUnidadeSuperior(unidade, unidades)),
    (unidade) => unidade.codigoUnidade
  )

export const getUnidadesAtuaisLabelAbrev = (unidadesAtuais, unidades) => {
  const unidadesSuperioresAtuais = getUnidadesSuperioresAtuais(unidadesAtuais, unidades)
  const subunidadesAtuais = getSubunidadesAtuais(unidadesAtuais)
  let labelAbrev = null
  if (_.size(subunidadesAtuais)) {
    const subunidade = _.head(getUnidadesSorted(subunidadesAtuais))
    const unidadeSuperior = getUnidadeSuperior(subunidade, unidades)
    labelAbrev = `${unidadeSuperior.sigla.toUpperCase()} / ${subunidade.sigla.toUpperCase()}`
    labelAbrev =
      _.size(subunidadesAtuais) > 1
        ? `${labelAbrev} + ${_.size(subunidadesAtuais) - 1}`
        : labelAbrev
  } else if (_.size(unidadesSuperioresAtuais)) {
    const unidade = _.head(getUnidadesSorted(unidadesSuperioresAtuais))
    labelAbrev = unidade.sigla.toUpperCase()
    labelAbrev =
      _.size(unidadesSuperioresAtuais) > 1
        ? `${labelAbrev} + ${_.size(unidadesSuperioresAtuais) - 1}`
        : labelAbrev
  }

  return labelAbrev
}

export const getUnidadesAtuaisLabel = (unidadesAtuais) =>
  _.join(
    _.values(unidadesAtuais).map((unidade) => unidade.sigla.toUpperCase()),
    ', '
  )

export const isUnidade = (unidade) => !isSubunidade(unidade)

export const isSubunidade = (unidade) =>
  unidade.codigoUnidadeSuperior &&
  (unidade.nivel === NIVEL_UNIDADE_DIRETORIA || unidade.nivel === NIVEL_UNIDADE_ASSESORIA)

export const getSubunidadesAtuais = (unidadesAtuais) =>
  _.filter(unidadesAtuais, (unidade) => isSubunidade(unidade))

const removerSubunidades = (unidadeSuperior, prevUnidadesAtuais) => {
  let unidadesAtuais = prevUnidadesAtuais
  _.forEach(unidadeSuperior.subunidades, (subunidade) => {
    if (unidadesAtuais[subunidade.codigoUnidade]) {
      unidadesAtuais = _.omit(unidadesAtuais, subunidade.codigoUnidade)
    }
  })
  return unidadesAtuais
}

const removerSubunidadesAtuaisSeNecessario = (prevUnidadesAtuais, unidades) => {
  let unidadesAtuais = prevUnidadesAtuais
  const unidadesSuperioresAtuais = getUnidadesSuperioresAtuais(_.values(unidadesAtuais), unidades)
  if (_.size(unidadesSuperioresAtuais) > 1) {
    // unidadesAtuais = apenas unidades superiores em que o usuário tem visão...
    _.forEach(unidadesAtuais, (unidade) => {
      if (isSubunidade(unidade)) {
        unidadesAtuais = _.omit(unidadesAtuais, unidade.codigoUnidade)
      }
    })
  }

  return unidadesAtuais
}

export const findUnidadeByCodigoUnidade = (unidades, unidadeFinded) => {
  return _.find(unidades, (unidade) => unidade.codigoUnidade === unidadeFinded.codigoUnidade)
}

export const isSameUnidade = (unidade1, unidade2) => {
  if (unidade1 == null || unidade2 == null) return false
  return unidade1.codigoUnidade === unidade2.codigoUnidade
}

const getUnidadeSuperior = (unidade, unidades) =>
  isSubunidade(unidade) ? unidades[unidade.codigoUnidadeSuperior] : unidade

const getUnidadesSelecionadas = (unidades, unidade) => {
  if (!_.size(unidades) || !unidade) {
    throw new Error('unidades e unidade não devem ser nulos!')
  } else if (isSubunidade(unidade)) {
    return unidades[unidade.codigoUnidadeSuperior]
      ? _.find(
          unidades[unidade.codigoUnidadeSuperior].subunidades,
          (subunidade) => subunidade.codigoUnidade === unidade.codigoUnidade
        )
      : null
  } else {
    return unidades[unidade.codigoUnidade]
  }
}
